<!-- 记录汇总 -->
<template>
    <div>
        <el-dialog title="分类统计报表" :visible.sync="dialogTableVisible1" v-if="dialogTableVisible1" width="80%">
            <div style="margin-bottom: 10px">
                <el-tag style="margin-right: 10px;font-size: 16px;">总条目数：{{ count }}</el-tag>
                <el-tag type="danger" style="margin-right: 10px;font-size: 16px;" v-if="type == 'gl'">过滤后条目数：{{
                    returnData.list.length }}</el-tag>
                <el-button type="primary" @click="exportData" size="mini">导出</el-button>
            </div>
            <u-table :key="$store.state.tableNum" size="mini" id="tableData" :show-summary="true" ref="tableRef"
                :summary-method="getSummaries" :data="dataShow" :row-height="35" height="500" border style="width: 100%"
                @sort-change="sortChange" row-key="index" use-virtual>
                <u-table-column type="index" width="100"/>
                <u-table-column v-for="(tableValye, tableKey) in allFieldList" v-if="tableValye.isShow == 1"
                    :key="tableKey" show-overflow-tooltip :min-width="tableValye.fieldWeight"
                    :prop="tableValye.fieldEntity" :label="tableValye.fieldShow"
                    :sortable="tableValye.isSort == 1 && tableValye.fieldType == 'number' ? 'custom' : tableValye.isSort == 1 ? true : false">
                    <template slot-scope="scope">
                        <span
                            v-if="tableValye.fieldEntity == 'createTime' && scope.row[tableValye.fieldEntity] && String(scope.row[tableValye.fieldEntity]).length == 13">
                            {{ $common.getLocalTime(scope.row[tableValye.fieldEntity]) }}
                        </span>
                        <span
                            v-else-if="tableValye.fieldType == 'date' && scope.row[tableValye.fieldEntity] && String(scope.row[tableValye.fieldEntity]).length != 13">
                            {{ scope.row[tableValye.fieldEntity] }}
                        </span>
                        <span
                            v-else-if="tableValye.fieldType == 'date' && scope.row[tableValye.fieldEntity] && String(scope.row[tableValye.fieldEntity]).length == 13">
                            {{ $common.getLocalTime(scope.row[tableValye.fieldEntity]) }}
                        </span>
                        <span v-else-if="tableValye.fieldType == 'formatter'">
                            <span v-for="(item, index) in JSON.parse(tableValye.formatterContent)" :key="index">
                                <el-tag size="mini" v-if="item.key == scope.row[tableValye.fieldEntity]">
                                    {{ item.value }}
                                </el-tag>
                            </span>
                        </span>

                        <span v-else-if="tableValye.isRift == 1">
                            <a @click="toDetail(scope.row[tableValye.riftField])">{{ scope.row[tableValye.fieldEntity]
                                }}</a>
                        </span>
                        <span v-else>
                            {{ scope.row[tableValye.fieldEntity] }}
                        </span>
                    </template>
                </u-table-column>
                <u-table-column label="合并条目数" prop="total" v-if="type == 'hb'" fixed="right"></u-table-column>
            </u-table>
            <div class="page_content_bottom">
                <el-pagination background @size-change="setDataPageSize" @current-change="setDataPageNumber"
                    :current-page.sync="currentPage" :page-size.sync="pageSize" :page-sizes="rpmPage"
                    layout="total, sizes, prev, pager, next, jumper" :total="total">
                </el-pagination>
            </div>
        </el-dialog>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
export default {
    name: "summaryReport",
    props: ["actionData"],
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
            dialogTableVisible: false,
            multipleSelection: [],
            orderData: [],
            fileIds: [],
            fileType: false,
            printSource: '',
            strSelect: [],
            numSelect: [],
            numberField: [],
            stringField: [],
            list: [],
            selString: [],
            selNumber: [],
            dialogTableVisible1: false,
            allFieldList: [],
            dataShow: [],
            dateField: [],
            excelData: [],
            rpcName: '',
            count: '',
            type: '',
            datalist: [],
            // 共几页
            pageNum: 1,
            // 每页显示数量
            pageSize: 100,
            // 当前显示页码
            currentPage: 1,
            // 总共多少条数据
            total: 1,
            // 当前要显示的数据
            rpmPage: [100, 500, 1000, 3000, 5000, 10000],
            totalPageData: [],
            returnData: {
                list: [],
            }
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {},
    //方法集合
    methods: {
        // 数据翻页
        setDataPageNumber(val) {
            this.dataShow = this.totalPageData[val - 1];
        },
        // 切换显示条数
        setDataPageSize(val) {
            this.pageSize = val;
            // 重新计算页数并分组
            this.calcPageData();
        },
        // 前端分页逻辑
        calcPageData() {
            // 计算页数(根据后台数据的条数和每页显示数量算出一共几页,得0时设为1)
            if (this.returnData.list.length > 1) {
                this.pageNum = Math.ceil(this.returnData.list.length / this.pageSize) || 1;
            }
            // 数据分组
            for (let i = 0; i < this.pageNum; i++) {
                // 每一页都是一个数组 形如 [['第一页的数据'],['第二页的数据'],['第三页数据']]
                // 根据每页显示数量 将后台的数据分割到 每一页,假设pageSize为5， 则第一页是1-5条，即slice(0,5)，第二页是6-10条，即slice(5,10)...
                this.totalPageData[i] = this.returnData.list.slice(
                    this.pageSize * i,
                    this.pageSize * (i + 1)
                );
            }
            // 获取到数据后显示第一页内容,数组下标是从0开始的，这里一定要减去1，不然会丢失一组数据
            this.dataShow = this.totalPageData[this.currentPage - 1];
            // this.fullscreenLoading = false
        },
        //触发按钮点击下载事件
        exportData() {
            this.excelData = this.dataShow; //将你要导出的数组数据（historyList）赋值给excelDate
            this.export2Excel(); //调用export2Excel函数，填写表头（clomns里的type）和对应字段(historyList里的属性名)
        },
        //表格数据写入excel
        export2Excel() {
            var nameList = []; //表格头 显示的所有字段
            var fieldList = []; //所有字段 显示的所有字段
            var timeList = []; //date类型的字段 导出之前进行格式转换
            var numList = []; //date类型的字段 导出之前进行格式转换
            // 循环当前tab表格信息
            this.allFieldList.forEach((item) => {
                // 显示的字段
                if (item.isShow == 1) {
                    nameList.push(item.fieldShow);
                    fieldList.push(item.fieldEntity);
                }
                // 如果为date类型push
                if (item.fieldType == "date") {
                    timeList.push(item.fieldEntity);
                }
                if (item.fieldType == "dateTime") {
                    timeList.push(item.fieldEntity);
                }
                if (item.fieldType == "formatter") {
                    timeList.push(item);
                }
                if (item.fieldType == "number") {
                    timeList.push(item);
                }
            });
            // 循环数据列表和时间字段数组 进行转换
            var arr = []
            var datas = JSON.parse(JSON.stringify(this.returnData.list))
            datas.forEach((item) => {
                timeList.forEach((timeitem) => {
                    if (timeitem.fieldType == "formatter") {
                        arr = JSON.parse(timeitem.formatterContent)
                        arr.forEach(item1 => {
                            if (item1.key == item[timeitem.fieldEntity]) {
                                item[timeitem.fieldEntity] = item1.value
                            }
                        })
                    } else if (timeitem.fieldType == "number") {
                        item[timeitem.fieldEntity] = Number(item[timeitem.fieldEntity])
                    } else if (timeitem.fieldType == "dateTime") {
                        if (item[timeitem] && String(item[timeitem]).indexOf('-') != -1) {
                            item[timeitem] = item[timeitem];
                        } else if (item[timeitem] && String(item[timeitem]).indexOf('-') == -1) {
                            item[timeitem] = this.$common.getLocalTime(item[timeitem], true)
                        } else {
                            item[timeitem] = ""
                        }
                    } else {
                        if (item[timeitem] && String(item[timeitem]).indexOf('-') != -1) {
                            item[timeitem] = item[timeitem];
                        } else if (item[timeitem] && String(item[timeitem]).indexOf('-') == -1) {
                            item[timeitem] = this.$common.getLocalTime(item[timeitem])
                        } else {
                            item[timeitem] = ""
                        }
                    }
                });
            });
            if (this.type == 'hb') {
                nameList.push('合并条目数')
                fieldList.push('total')
            }
            // 导出业务逻辑 引用封装好的js方法
            require.ensure([], () => {
                const {
                    export_json_to_excel
                } = require("@/assets/excel/Export2Excel");
                //这里使用绝对路径( @表示src文件夹 )，使用@/+存放export2Excel的路径
                const tHeader = nameList; // 导出的excel表头名信息
                const filterVal = fieldList; // 导出的excel表头字段名，需要导出表格字段名
                const list = datas; // 查询的数据list
                // 进行数据json map 格式转换
                const data = this.formatJson(filterVal, list);
                // 调用方法传参      表头名信息 数据  导出的表格名称
                export_json_to_excel(tHeader, data, this.rpcName);
            });

        },
        //格式转换方法
        formatJson(filterVal, jsonData) {
            return jsonData.map((v) => filterVal.map((j) => v[j]));
        },
        // 自定义合计字段
        getSummaries(param) {
            //过滤出来需要合计的字段
            const dateList = this.allFieldList.filter(item => item.isTotal && item.fieldType == 'number').map(item => item.fieldEntity)
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '合计';
                    return;
                }
                const values = data.map(item => Number(item[column.property]));
                //遍历得到该字段是否需要合并，若需合并则记录索引 后续进行合并
                let dataIndex = dateList.findIndex(items => items == column.property)
                if (dataIndex !== -1) dataIndex = index
                if (!values.every(value => isNaN(value)) && index == dataIndex) {
                    sums[index] = values.reduce((prev, curr) => {
                        const value = Number(curr);
                        if (!isNaN(value)) {
                            return NP.plus(Number(prev), Number(curr));
                        } else {
                            return prev;
                        }
                    }, 0);
                    sums[index] = this.$common.getDecimalInfo(3, sums[index])
                } else {
                    sums[index] = '';
                }
            });
            return [sums];
        },
        sortChange(column) {
         this.returnData.list=this.$common.sortChange(column,this.datalist,this.allFieldList,'fieldEntity')
         this.currentPage = 1
         this.calcPageData()
        },
        openBox(data) {
            this.allFieldList = data.allFieldList
            this.total = data.dataShow.length
            this.datalist = JSON.parse(JSON.stringify(data.dataShow))
            this.returnData.list = JSON.parse(JSON.stringify(data.dataShow))
            this.rpcName = data.rpcName
            this.count = data.count
            this.type = data.type
            this.dialogTableVisible1 = true
            console.log(this.datalist);
            console.log(this.returnData.list);
            this.calcPageData()

        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.printSource = sessionStorage.getItem('printSource').replace(/\"/g, "");
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        if (!this.$store.state.tableNum) {
            this.$store.state.tableNum = true
        } else {
            this.$store.state.tableNum = false
        }
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {

    }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.totalBox {
    width: 230px;
}

.dis {
    display: flex;
}

.checkBox {
    border: 1px solid #dcdfe6;
    padding: 10px;
}

::v-deep .el-checkbox.is-bordered.el-checkbox--mini {
    width: 210px;
    margin-left: 0;
}
</style>